import React, { useState } from "react"

import { Form, Formik } from "formik"
import { NotificationManager } from "react-notifications"

import { FlagIcon } from "@heroicons/react/24/outline"

import { Color } from "~tailwindui/types/enums"

import { Button } from "~tailwindui/Basics"
import { SubmitButton } from "~tailwindui/Form"
import Modal from "~tailwindui/Modal"

import { gql, useClient, useMutation } from "hooks/urql"

import {
  FormFailures,
  handleFailure,
} from "components/Forms/Formik/hookComponents"

export type ReportMessageButtonProps = {
  messageId: string
}

const ReportMessageButton: React.FC<ReportMessageButtonProps> = ({
  messageId,
}) => {
  const [hideFlag, setHideFlag] = useState(false)
  const [open, setOpen] = useState(false)
  const client = useClient()
  const [, runMutation]: any[] = useMutation(reportMessageMutation, client)

  const reportMessage = (values, actions) => {
    runMutation(values)
      .then(
        result => {
          const { failures } = result.data.reportMessage
          if (failures.length > 0) {
            handleFailure(actions, failures)
          } else {
            setOpen(false)
            NotificationManager.success("Message reported.")
            setHideFlag(true)
          }
        },
        () => handleFailure(actions)
      )
      .catch(() => handleFailure(actions))
  }

  if (hideFlag) return null

  return (
    <>
      <FlagIcon
        className="h-6 w-6 cursor-pointer text-red-500"
        onClick={() => setOpen(true)}
      />

      <Modal.Dialog hideButton isOpen={open} closeModal={() => setOpen(false)}>
        <Formik initialValues={{ messageId }} onSubmit={reportMessage}>
          <Form>
            <Modal.Header Icon={FlagIcon} iconClassNames="text-red-500">
              Report Message
            </Modal.Header>
            <Modal.Body>
              <p>
                If you feel the content of this message is inappropriate or
                unprofessional, please click "Report" and an admin will be
                prompted to review it.
              </p>
            </Modal.Body>
            <Modal.Footer>
              <div className="flex w-full flex-col space-y-4">
                <FormFailures />
                <div className="flex w-full justify-between">
                  <Button onClick={() => setOpen(false)}>Cancel</Button>
                  <SubmitButton text="Report" color={Color.Red} />
                </div>
              </div>
            </Modal.Footer>
          </Form>
        </Formik>
      </Modal.Dialog>
    </>
  )
}

const reportMessageMutation = gql`
  mutation ReportMessage($messageId: ID!) {
    reportMessage(messageId: $messageId) {
      failures {
        message
      }
    }
  }
`

export default ReportMessageButton
